import React from 'react';
import './styles.css';

const RoundButton = ({ content, disabled, onClick, color, borderColor, backgroundColor, flat }) => (
  <button
    className="round-button"
    disabled={disabled}
    onClick={onClick}
    style={{
      color,
      backgroundColor,
      border: `solid 1px ${borderColor}`,
      boxShadow: flat ? '' : '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
    }}
  >
    {content}
  </button>
);

RoundButton.propTypes = {
  content: React.PropTypes.any,
  disabled: React.PropTypes.bool,
  onClick: React.PropTypes.func,
  color: React.PropTypes.string,
  borderColor: React.PropTypes.string,
  backgroundColor: React.PropTypes.string,
  flat: React.PropTypes.bool,
};

export default RoundButton;



// WEBPACK FOOTER //
// ./src/browser/app/components/RoundButton/RoundButton.js